import React, { Component } from "react";

const BannerItem = props => {
  return (
    <div className={`p-content-page-right-banner-item`} onClick={props.onClick}>
      <span style={{ color: props.color ? props.color : null }} className={`p-content-page-right-banner-item-nb`}>
        {props.value}
      </span>
      <span className={`p-content-page-right-banner-item-txt`}>{props.label}</span>
    </div>
  );
};

class IndicatorBanner extends Component {
  render() {
    const { items, size } = this.props;
    let bannerItems = items.map((item, d) => {
      return (
        <BannerItem
          key={d}
          label={item.label}
          value={item.value}
          color={item.color}
          onClick={item.onClick}
          size={size}
        />
      );
    });
    return <div className="p-content-page-right-banner">{bannerItems}</div>;
  }
}

export default IndicatorBanner;



// WEBPACK FOOTER //
// src/components/indicators/IndicatorBanner.js